<template>
  <div class="choice-question-container">
    <!-- 题目标题和内容 -->
    <div class="question-header">
      <div class="title-section">
        <span class="question-number">
          <a-tag color="blue">选择题</a-tag>
          <a-tag v-if="drill.required" color="red">必做题</a-tag>
          <a-tag v-if="drill.id" color="green">已保存</a-tag>
        </span>
      </div>
      <div> 
        <a @click="saveEdit">
          <a-icon type="save" v-if="!loading" /> 
          <a-icon type="loading" v-if="loading" />
          保存
        </a>
        <a-divider type="vertical" />
        <a @click="editDrill"><a-icon type="edit"/> 编辑</a>
      </div>
    </div>
    
    <!-- 题目文本 -->
    <div class="question-text">
      <span>{{ index + 1 }}.</span>
      <span v-html="formatQuestionText(drill.text)"></span>
    </div>
    
    <!-- 选项列表 -->
    <div class="options-container">
      <div 
        v-for="option in drill.optionList" 
        :key="option.id"
        class="option-item"
        :class="{ 'correct-option': option.correctAnswer }"
      >
        <span class="option-label">{{ option.id }}.</span>
        <span class="option-text">{{ option.text }}</span>
        <a-icon v-if="option.correctAnswer" type="check-circle" class="correct-icon" />
      </div>
    </div>
    
    <!-- 正确答案 -->
    <div class="correct-answer-section">
      <strong>正确答案：</strong>
      <a-tag v-for="answer in drill.correctAnswer" :key="answer" color="green">
        {{ answer }}
      </a-tag>
    </div>
    
    <!-- 解析 -->
    <div v-if="drill.explanation" class="explanation-section">
      <h4><a-icon type="bulb" /> 解析</h4>
      <div class="explanation-content">{{ drill.explanation }}</div>
    </div>
    
    <!-- 知识点 -->
    <div v-if="drill.knowledge_points" class="knowledge-points-section">
      <h4><a-icon type="book" /> 知识点</h4>
      <div class="knowledge-points-content" v-html="formatKnowledgePoints(drill.knowledge_points)"></div>
    </div>
    <a-divider />
    <a-drawer
      title="编辑选择题"
      placement="right"
      width="60%"
      :closable="false"
      :visible="visible"
      @close="onClose">
      
      <div class="edit-form">
        <!-- 操作按钮 -->
        <div class="form-actions">
          <a-button type="primary" :loading="loading" @click="saveEdit" style="margin-right: 8px;">
            <a-icon type="save" /> 保存
          </a-button>
          <a-button @click="cancelEdit">
            <a-icon type="close" /> 取消
          </a-button>
        </div>

        <!-- 题目文本编辑 -->
        <div class="form-section">
          <h4>题目内容</h4>
          <a-textarea 
            v-model="editData.text" 
            placeholder="请输入题目内容"
            :rows="4"
            style="margin-bottom: 16px;"
          />
        </div>

        <!-- 选项编辑 -->
        <div class="form-section">
          <div class="section-header">
            <h4>选项设置</h4>
            <a-button 
              type="dashed" 
              size="small" 
              @click="addOption"
              :disabled="editData.optionList && editData.optionList.length >= 6"
            >
              <a-icon type="plus" /> 添加选项
            </a-button>
          </div>
          <div 
            v-for="(option, optionIndex) in editData.optionList" 
            :key="option.id"
            class="option-edit-item"
          >
            <div class="option-header">
              <span class="option-label">{{ option.id }}.</span>
              <a-checkbox 
                :checked="option.correctAnswer"
                @change="(e) => toggleCorrectAnswer(option.id, e.target.checked)"
              >
                正确答案
              </a-checkbox>
              <a-button 
                type="link" 
                size="small" 
                @click="removeOption(optionIndex)"
                :disabled="editData.optionList && editData.optionList.length <= 2"
                style="color: #ff4d4f; margin-left: auto;"
              >
                <a-icon type="delete" /> 删除
              </a-button>
            </div>
            <a-input 
              v-model="option.text" 
              placeholder="请输入选项内容"
              style="margin-bottom: 12px;"
            />
          </div>
        </div>

        <!-- 解析编辑 -->
        <div class="form-section">
          <h4>题目解析</h4>
          <a-textarea 
            v-model="editData.explanation" 
            placeholder="请输入题目解析"
            :rows="3"
            style="margin-bottom: 16px;"
          />
        </div>

        <!-- 知识点编辑 -->
        <div class="form-section">
          <h4>知识点</h4>
          <a-textarea 
            v-model="editData.knowledge_points" 
            placeholder="请输入知识点，格式：- [知识点名称] {data-hash=&quot;hash值&quot;}"
            :rows="3"
            style="margin-bottom: 16px;"
          />
        </div>

        <!-- 题目设置 -->
        <div class="form-section">
          <h4>题目设置</h4>
          <a-checkbox 
            :checked="editData.required"
            @change="(e) => onRequiredChange(e.target.checked)"
            style="margin-bottom: 16px;"
          >
            必做题
          </a-checkbox>
          <div class="setting-description">
            勾选后，此题目将被标记为必做题，学生必须完成此题目才能继续学习。
          </div>
        </div>

        
      </div>
    </a-drawer>
  </div>
</template>

<script>
import ChoiceQuestionDrillApi from '../../../../api/src/drill/api/ChoiceQuestionDrillApi.js'
const choiceQuestionDrillApi = new ChoiceQuestionDrillApi()
export default {
  name: "ChoiceQuestionAIEdit",
  props: {
    drill: {
      type: Object,
      required: true,
      default: () => ({})
    },
    index: Number,
    sectionId: String,
  },
  data() {
    return {
      loading: false,
      visible: false,
      editData: {}
    }
  },
  mounted() {
    console.log('mounted')
    console.log(this.drill)

    this.editData = JSON.parse(JSON.stringify(this.drill));
      
    // 确保 required 字段有默认值
    if (this.editData.required === undefined || this.editData.required === null) {
      this.editData.required = false;
    }
  },
  methods: {
    // 格式化题目文本，处理换行
    formatQuestionText(text) {
      if (!text) return '';
      return text.replace(/\n/g, '<br>');
    },
    
    // 格式化知识点，处理特殊格式
    formatKnowledgePoints(points) {
      if (!points) return '';
      
      // 处理知识点格式，将 - [知识点名称] {data-hash="xxx"} 转换为更友好的显示
      return points
        // .replace(/- \[(.*?)\] \{data-hash="(.*?)"\}/g, '<span class="knowledge-point">• $1</span>')
        .replace(/\n/g, '<br>');
    },

    editDrill() {
      if(this.loading) {
        return
      }
      console.log('editDrill')
      console.log(this.drill)
      // 深拷贝原始数据到编辑数据中
      this.editData = JSON.parse(JSON.stringify(this.drill));
      
      // 确保 required 字段有默认值
      if (this.editData.required === undefined || this.editData.required === null) {
        this.editData.required = false;
      }
      
      this.visible = true;
    },
    
    onClose() {
      this.visible = false;
    },
    
    // 切换正确答案
    toggleCorrectAnswer(optionId, isCorrect) {
      // 更新选项的正确答案状态
      const option = this.editData.optionList.find(opt => opt.id === optionId);
      if (option) {
        option.correctAnswer = isCorrect;
      }
      
      // 更新 correctAnswer 数组
      if (isCorrect) {
        if (!this.editData.correctAnswer.includes(optionId)) {
          this.editData.correctAnswer.push(optionId);
        }
      } else {
        this.editData.correctAnswer = this.editData.correctAnswer.filter(id => id !== optionId);
      }
    },
    
    // 保存编辑
    async saveEdit() {
      if(this.loading) {
        return
      }
      this.loading = true
      // 验证数据
      if (!this.editData.text || !this.editData.text.trim()) {
        this.$message.warning('请输入题目内容');
        return;
      }
      
      if (!this.editData.optionList || this.editData.optionList.length === 0) {
        this.$message.warning('请设置选项');
        return;
      }
      
      if (!this.editData.correctAnswer || this.editData.correctAnswer.length === 0) {
        this.$message.warning('请至少选择一个正确答案');
        return;
      }
      
      // 检查选项内容是否为空
      for (let option of this.editData.optionList) {
        if (!option.text || !option.text.trim()) {
          this.$message.warning(`请填写选项 ${option.id} 的内容`);
          return;
        }
      }

      console.log(this.editData)
      let id = await this.saveEditData(this.editData)
      this.editData.id = id
      // 触发保存事件，将编辑后的数据传递给父组件
      this.$emit('updateDrill', {index: this.index, drill: this.editData});
      this.$message.success('题目修改成功');
      this.visible = false;
      this.loading = false
    },

    async saveEditData(drill) {
      this.loading = true
      let id = undefined
      if(!drill.id){
        let resp = await choiceQuestionDrillApi.create(drill, {
          sectionId: this.sectionId,
          sortKey: 0
        })
        console.log(resp)
        id = resp.id
      }else{
        await choiceQuestionDrillApi.update(drill.id, drill)
        id = drill.id
      }
      this.loading = false
      return id
    },
    
    // 取消编辑
    cancelEdit() {
      this.editData = {};
      this.visible = false;
    },
    
    // 添加选项
    addOption() {
      if (!this.editData.optionList) {
        this.editData.optionList = [];
      }
      
      // 限制最多6个选项
      if (this.editData.optionList.length >= 6) {
        this.$message.warning('最多只能添加6个选项');
        return;
      }
      
      // 获取下一个选项标识符
      const existingIds = this.editData.optionList.map(opt => opt.id);
      const availableIds = ['A', 'B', 'C', 'D', 'E', 'F'];
      const nextId = availableIds.find(id => !existingIds.includes(id));
      
      if (!nextId) {
        this.$message.warning('无法添加更多选项');
        return;
      }
      
      // 添加新选项
      const newOption = {
        id: nextId,
        text: '',
        correctAnswer: false
      };
      
      this.editData.optionList.push(newOption);
      this.$message.success(`已添加选项 ${nextId}`);
    },
    
    // 删除选项
    removeOption(optionIndex) {
      if (!this.editData.optionList || this.editData.optionList.length <= 2) {
        this.$message.warning('至少需要保留2个选项');
        return;
      }
      
      const removedOption = this.editData.optionList[optionIndex];
      
      // 如果删除的是正确答案，需要从correctAnswer数组中移除
      if (removedOption.correctAnswer && this.editData.correctAnswer) {
        this.editData.correctAnswer = this.editData.correctAnswer.filter(
          id => id !== removedOption.id
        );
      }
      
      // 从选项列表中删除
      this.editData.optionList.splice(optionIndex, 1);
      this.$message.success(`已删除选项 ${removedOption.id}`);
    },
    
    // 必做题状态变更
    onRequiredChange(isRequired) {
      console.log('必做题状态变更:', isRequired);
      
      // 更新必做题状态
      this.editData.required = isRequired;
      console.log(this.editData)
      if (isRequired) {
        this.$message.info('已设置为必做题');
      } else {
        this.$message.info('已取消必做题设置');
      }
    },
  }
}
</script>

<style scoped lang="less">
.choice-question-container {
  // border: 1px solid #e8e8e8;
  border-radius: 4px;
  // padding: 12px;
  margin-bottom: 12px;
  // background-color: #fafafa;
  
  .question-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
    
    .title-section {
      display: flex;
      align-items: center;
    }
    
    .question-number {
      font-weight: bold;
      font-size: 14px;
      display: flex;
      align-items: center;
      gap: 8px;
      // color: #1890ff;
    }
  }
  
  .question-text {
    font-size: 14px;
    line-height: 1.5;
    margin-bottom: 10px;
    color: #262626;
    font-weight: 500;
  }
  
  .options-container {
    margin-bottom: 10px;
    
    .option-item {
      display: flex;
      align-items: center;
      padding: 6px 10px;
      margin-bottom: 6px;
      border: 1px solid #d9d9d9;
      border-radius: 3px;
      background-color: #fff;
      transition: all 0.3s;
      
      &.correct-option {
        border-color: #52c41a;
        background-color: #f6ffed;
        
        .option-label {
          color: #52c41a;
          font-weight: bold;
        }
      }
      
      .option-label {
        font-weight: bold;
        margin-right: 6px;
        min-width: 18px;
        color: #595959;
        font-size: 13px;
      }
      
      .option-text {
        flex: 1;
        color: #262626;
        font-size: 13px;
      }
      
      .correct-icon {
        color: #52c41a;
        font-size: 14px;
        margin-left: 6px;
      }
    }
  }
  
  .correct-answer-section {
    margin-bottom: 10px;
    padding: 8px;
    background-color: #f0f9ff;
    border-left: 3px solid #1890ff;
    border-radius: 3px;
    
    strong {
      color: #1890ff;
      margin-right: 6px;
      font-size: 13px;
    }
  }
  
  .explanation-section {
    margin-bottom: 10px;
    padding: 8px;
    background-color: #fffbe6;
    border-left: 3px solid #faad14;
    border-radius: 3px;
    
    h4 {
      margin: 0 0 6px 0;
      color: #faad14;
      font-size: 13px;
      
      i {
        margin-right: 3px;
      }
    }
    
    .explanation-content {
      color: #595959;
      line-height: 1.5;
      font-size: 13px;
    }
  }
  
  .knowledge-points-section {
    padding: 8px;
    background-color: #f6ffed;
    border-left: 3px solid #52c41a;
    border-radius: 3px;
    
    h4 {
      margin: 0 0 6px 0;
      color: #52c41a;
      font-size: 13px;
      
      i {
        margin-right: 3px;
      }
    }
    
    .knowledge-points-content {
      color: #595959;
      line-height: 1.5;
      font-size: 13px;
      
      .knowledge-point {
        display: inline-block;
        margin: 1px 6px 1px 0;
        padding: 1px 6px;
        background-color: #52c41a;
        color: white;
        border-radius: 10px;
        font-size: 11px;
      }
    }
  }
}

// 编辑表单样式
.edit-form {
  // padding: 16px;
  
  .form-section {
    margin-bottom: 24px;
    
    h4 {
      margin-bottom: 12px;
      color: #262626;
      font-size: 14px;
      font-weight: 600;
    }
    
    .section-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;
      
      h4 {
        margin-bottom: 0;
      }
    }
  }
  
  .option-edit-item {
    margin-bottom: 16px;
    padding: 12px;
    border: 1px solid #f0f0f0;
    border-radius: 4px;
    background-color: #fafafa;
    
    .option-header {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      
      .option-label {
        font-weight: bold;
        margin-right: 12px;
        min-width: 24px;
        color: #1890ff;
      }
    }
  }
  
  .form-actions {
    // padding-top: 16px;
    // border-top: 1px solid #f0f0f0;
    text-align: right;
  }
  
  .setting-description {
    color: #8c8c8c;
    font-size: 12px;
    line-height: 1.4;
    margin-top: 4px;
  }
}
</style>